import React, { useEffect, useState } from "react";
import { IStatsRow } from "./interfaces";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./style.scss"

const Stats = ({ statsArr }: { statsArr: Array<IStatsRow> }) => {
  const [showPaginator, setShowPaginator] = useState<boolean>(false);
  const maxDatasetPerPage: number = 5;

  useEffect(() => {
    if (statsArr?.length > maxDatasetPerPage) {
      setShowPaginator(true);
    } else setShowPaginator(false);
  }, []);

  return (
    <div className="stats datatable">
      <DataTable
        value={statsArr}
        paginator={showPaginator}
        responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={5}
        className="datatable text row w-max"
      >
        <Column field="title" header="Title" sortable className="row w-max"></Column>
        <Column field="unit" header="unit" sortable className="row"></Column>
        <Column field="pointCount" header="count" sortable className="row"></Column>
        <Column field="min" header="min" sortable className="row"></Column>
        <Column field="max" header="max" sortable className="row"></Column>
        <Column field="delta" header="delta" sortable className="row"></Column>
        <Column field="mean" header="mean" sortable className="row"></Column>
      </DataTable>
    </div>
  );
};

export default Stats;
